import { useStore } from "vuex";
import { ref, computed, watch } from "vue";
import swalUtil from "@/utils/sweetalertUtil";
import {useRouter} from "vue-router";
import { useI18n } from "vue-i18n";

const usePsycologistsOptions = () => {  
  const store = useStore();
  const router = useRouter();
  const { t } = useI18n();
 
  const psychologist = ref({});

  const psychologists = ref({
    first: null,
    second: null,
    third: null,
    quarter: null,
  });

  const dummyData = {"photo_url":"check2.png","audio":null,"psychologist_id":5,"user_id":5,"name":"Jose Escalante","description":null,"years_experience":65,"direction":"Monterrey, Nuevo León, México","individual_session_price":1000,"couple_session_price":0,"specialitiesNames":["Manejo de emociones","Estrés","Atracones","Adaptación para enfermedades somáticas","Dificultades para dormir","Agotamiento emocional/profesional","Dudas sobre mi carrera o profesión","Procrastinación","Desbalance trabajo/vida","Autoestima","Orientación sexual","Desmotivación","Insatisfecho con mi apariencia física","Conflictos en relaciones","Planificación familiar","Cambios de vida","Procesar recuerdos","Duelo/perdida","Autoconocimiento","Problemas en la toma de decisiones"],"interval":10,"max_duration":50,"dates_availables":{"11/09/2023":[{"hour_start":"10:55:00","hour_end":"13:40:00"},{"hour_start":"14:45:00","hour_end":"17:50:00"}],"13/09/2023":[{"hour_start":"11:00:00","hour_end":"12:00:00"},{"hour_start":"16:00:00","hour_end":"17:50:00"}],"18/09/2023":[{"hour_start":"10:55:00","hour_end":"17:50:00"}]}}

  
  const loading = ref(false);
  const psychologistsArray = computed(() => store.getters['psycologistsOptions/getPsychologits'])
  const reasons = computed(() => store.getters[`auth/getDataStoreByKey`]('reasons'));
  const partner = computed(() => store.getters[`auth/getDataStoreByKey`]('partner'));
  const answers = computed(() => store.getters[`auth/getDataStoreByKey`]('answers'));
  const timezone = computed(() => store.getters['auth/getBrowserTimezone'])

  const handleError = (title) => swalUtil.fire({ icon: "error", title, timer: 3000 });
  const user = computed(() => store.getters[`auth/getLoggedUser`]);
  const matchFound = computed(() => store.getters['getPsyMatchesFound'])

  const getCatalogs = async () => {
    loading.value = true;
    const tz = timezone.value    
    let res = await store.dispatch(`psycologistsOptions/getMatching`, JSON.parse(JSON.stringify({ 
      reasons: reasons.value, 
      partner: partner.value, 
      timezone: tz,
      patient_id: user.value?.patient_id,
      ids_psychologits_ignore: psychologistsArray.value.map(el => el.psychologist_id)
    })))
    if (res.error) return handleError(res.message);
    psychologists.value = res.data
    // store.commit('setPsyMatchesFound', psychologists.value.matching.length > 0);
    loading.value = psychologists.value.matching.length == 0;
  }; 
  
  const getPsychology = async (psychologistId) => {
    let res = await store.dispatch(`psycologistsOptions/getPsychology`, { id: psychologistId })
    if (res.error) return handleError(res.message);
    psychologist.value = res.data
  }; 

  const acceptInformedConsent = async (patient_id) => {
    const {data, error, message} = await store.dispatch('waitingRoom/acceptInformedConsent', patient_id)
    if(!error) {
      store.commit('auth/updateInformedConsent', 1)

      return {data, error, message}
    }
  }

  watch(matchFound, async () => {
    if (!matchFound.value) {
      const result = await swalUtil.fire({
        title: t('alert-title-message'),
        text: t('general-messages.no-psychologists'),
        icon: 'warning',
        allowOutsideClick: false,
        allowEscapeKey: false,
      })

      if (result.isConfirmed) {
        router.push('waiting-room')
      }
    }
  })


  return {
    reasons,
    partner,
    answers,
    psychologists,        
    psychologist,
    psychologistsArray,
    loading,
    dummyData,
    getPsychology,
    getCatalogs,
    acceptInformedConsent
  };
};
export default usePsycologistsOptions;
